module.exports = __webpack_public_path__ + "static/young-leader-photo-navita_christina_singh-08360a72b8ef078fc8d252bf4d1780a7.jpg";